import * as React from 'react';
import { FilterField, FilterSection } from './FilterSection';
import { FilterSelect } from './FilterSelect';
import { CONDITION_OPTIONS, USER_TYPE_OPTIONS } from '../constants';
import { RosterFilters } from './types';

/**
 * Attributes of the member rather than their care.
 *
 * Health Plan, Health System and Employer are intentionally absent — the brief
 * strikes all three. Condition replaces the old diagnosis picklist with the
 * coarser grouping care teams actually sort by; the specific diagnosis still
 * shows on the patient profile. Referring UTM was cut per team feedback
 * (Aug 2026) — not a filter care teams work a panel by.
 *
 * User Type is single-select (Aug 2026 filter-logic pass) — a member is
 * exactly one of True/Internal/Free, so "True or Internal" was never a real
 * question. Condition stays multi-select: a member can carry several
 * conditions, and asking for any one of them is the actual use case.
 */
export const MemberAttributesSection = ({
  filters,
}: {
  filters: RosterFilters;
}) => (
  <FilterSection title="Member Attributes">
    <FilterField label="User Type">
      <FilterSelect
        isMulti={false}
        placeholder="All"
        options={USER_TYPE_OPTIONS}
        selected={filters.selected.userTypes}
        onChange={(v) => filters.setFilter('userTypes', v)}
      />
    </FilterField>

    <FilterField label="Condition">
      <FilterSelect
        placeholder="All"
        options={CONDITION_OPTIONS}
        selected={filters.selected.conditions}
        onChange={(v) => filters.setFilter('conditions', v)}
      />
    </FilterField>
  </FilterSection>
);
